<template>
  <a :href="`tel:${phone}`" v-if="phone" class="button-circle scale-effect d-flex justify-content-center align-items-center">
      <slot />
  </a>
  <a :href="href" v-else-if="hyperlink" class="button-circle scale-effect d-flex justify-content-center align-items-center" :target="isExternalLink(href) ? '_blank' : null">
    <slot />
  </a>
  <button type="button" class="button-circle scale-effect d-flex justify-content-center align-items-center" v-else>
    <slot />
  </button>
</template>

<script>
import {isExternalLink} from "@/utils/utils";
export default {
  props: {
    phone: String,
    hyperlink: Boolean,
    href: String
  },
  data(){
    return {
      isExternalLink
    }
  }
}
</script>

<style scoped>

</style>
